<template>
  <ul class="pagination">
    <li class="page-item cursor-pointer" :class="{'disabled': isOnFirstPage}">
      <a class="page-link" href="" @click.prevent="loadPage('prev')">
        <span aria-hidden="true">&laquo;</span>
        <span class="sr-only">{{ 'Previous' | translate }}</span>
      </a>
    </li>
    
    <template v-if="notEnoughPages">
      <li v-for="n in totalPage" class="page-item cursor-pointer" :class="{'active': isCurrentPage(n)}">
        <a class="page-link" @click.prevent="loadPage(n)" v-html="n"></a>
      </li>
    </template>
    <template v-else>
      <li v-for="n in windowSize" class="page-item cursor-pointer" :class="{'active': isCurrentPage(windowStart+n-1)}">
        <a class="page-link" @click.prevent="loadPage(windowStart+n-1)" v-html="windowStart+n-1"></a>
      </li>
    </template>

    <li :class="{'disabled': isOnLastPage}">
      <a href="" class="page-item cursor-pointer" @click.prevent="loadPage('next')">
        <span aria-hidden="true">&raquo;</span>
        <span class="sr-only">{{ 'Next' | translate }}</span>
      </a>
    </li>
  </ul>
</template>

<script>
import VuetablePaginationMixin from 'vuetable-2/src/components/VuetablePaginationMixin'
export default {
  mixins: [VuetablePaginationMixin]
}
</script>


// WEBPACK FOOTER //
// VueTablePaginationCustom.vue?cb1aeb98